// A Packaging's Type (issue #317), as stored and as staff see it.
export const PACKAGING_TYPES = [
  { key: 'box', label: 'Box' },
  { key: 'mailer', label: 'Mailer' },
  { key: 'satchel', label: 'Satchel' },
];

export const packagingTypeLabel = (key) => PACKAGING_TYPES.find((t) => t.key === key)?.label || '—';
